import { CustomerDoc, EventDoc } from '@livekatsomo/models';
import { DebugDetails } from '@livekatsomo/web/ui-components/debug-details';
import {
  Breadcrumbs,
  Footer,
  Header,
  ThemedContainer,
} from '@livekatsomo/web/ui-components/layout';
import { CustomFontLoader } from '@livekatsomo/web/ui-components/theme';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { ReactNode, useMemo } from 'react';

export interface CustomerViewProps {
  customer: CustomerDoc;
  events?: EventDoc[] | null;
  menuItems?: ReactNode;
  userMenu: ReactNode;
  children?: ReactNode;
}

export function ChannelView({
  customer,
  events = [],
  menuItems,
  userMenu,
  children,
}: CustomerViewProps) {
  const theme = useMemo(() => createTheme(customer.theme), [customer.theme]);

  return (
    <ThemeProvider theme={theme}>
      <CustomFontLoader theme={theme} />
      <CssBaseline />
      <DebugDetails data={{ customer, events }} />
      <ThemedContainer>
        <Header
          title={!theme.katsomo?.header?.hideCustomerName ? customer.name : ''}
          drawerMenuItems={menuItems}
          userMenu={userMenu}
        />
        <Breadcrumbs sx={{ p: 1 }} />
        {children}
        <Footer />
      </ThemedContainer>
    </ThemeProvider>
  );
}

export default ChannelView;
